import { useMemo } from 'react';

type ProgressBarProps = {
    totalSteps: number;
    currentStep: number;
    currentLabel: string;
    nextLabel: string;
};

export const ProgressBar = ({ totalSteps, currentStep, currentLabel, nextLabel }: ProgressBarProps) => {
    const C = 251.2;
    const strokeDasharray = `${C}, ${C}`;

    const strokeDashOffset = useMemo(() => {
        const progress = (currentStep / totalSteps) * 100;
        return C - (C * progress) / 100;
    }, [C, currentStep, totalSteps]);

    return (
        <div data-component="progress-bar" className="r-flex r-items-center r-gap-4">
            <div
                className="r-h-24 r-w-24"
                role="progressbar"
                aria-valuemin={1}
                aria-valuemax={totalSteps}
                aria-valuenow={currentStep}
                aria-labelledby="progress-bar-label"
            >
                <svg viewBox="0 0 100 100">
                    <path
                        strokeWidth="10"
                        strokeLinecap="round"
                        strokeDasharray={strokeDasharray}
                        className="r-fill-none r-stroke-gray-200"
                        d="M50 10 a 40 40 0 0 1 0 80 a 40 40 0 0 1 0 -80"
                    />
                    <path
                        strokeWidth="10"
                        strokeLinecap="round"
                        strokeDasharray={strokeDasharray}
                        strokeDashoffset={strokeDashOffset}
                        d="M50 10 a 40 40 0 0 1 0 80 a 40 40 0 0 1 0 -80"
                        className="r-fill-none r-stroke-primary r-transition-all r-duration-1000 r-ease-in-out"
                    />
                    <text x="50" y="50" textAnchor="middle" dy="11" fontSize="28" fontWeight="bold">
                        {currentStep}/{totalSteps}
                    </text>
                </svg>
            </div>
            <div className="r-space-y-4" id="progress-bar-label">
                <p className="r-text-2xl r-font-bold">{currentLabel}</p>
                {nextLabel ? <p>Nästa steg: {nextLabel}</p> : null}
            </div>
        </div>
    );
};
